import React from 'react';
import { OfferBox } from '../ui/OfferBox';
import { priceIncludes } from '../../data/offer';
export function PriceCTA() {
  return <section id="offer" className="w-full bg-ink px-4 py-16 md:py-24" data-id="element-223" data-mp="2dl95ox3mhvz">
      <div className="mx-auto max-w-3xl text-center" data-id="element-224" data-mp="3ui5ng11izpx4">
        <p className="font-display text-sm font-extrabold uppercase tracking-wide text-cyan md:text-base" data-id="element-225" data-mp="3uks20kmu35ou">Limited promotional price</p>
        <h2 className="mt-3 font-display text-[40px] font-black uppercase leading-none tracking-tight text-white md:text-6xl" data-id="element-226" data-mp="q4yzxqflq5eu">
          Your price: just <span className="text-gold" data-id="element-227" data-mp="m3x8hvrxexnf">$27 USD</span>
        </h2>
        <p className="mt-4 text-lg text-white/75" data-id="element-228" data-mp="hbdks5ziym4w">
          Get the complete HAIR TRANSPLANT BLUEPRINT™ for $27 · Digital product · One-time payment
        </p>
      </div>
      <div className="mt-10" data-id="element-229" data-mp="19sg8lo0to44f">
        <OfferBox includesTitle="Your collection includes:" includes={priceIncludes} ctaLabel="Get instant access" ctaSub="Your final currency conversion, payment options, and access details will be displayed at checkout." data-id="element-230" data-mp="19trjs8wlke5k" />
      </div>
    </section>;
}